const BASE = 'https://hediyatik.com.tr/pictures/';

const commonFeatures = [
  'Mermer tozu / kalsiyum karbonat bazlı taş tozu harç',
  'Pürüzsüz yüzey, mermer efektli lüks görünüm',
  'Yüksek dayanımlı, kırılmaya karşı dirençli yapı',
  'Doğal dokulu, el emeği el yapımı obje',
  'Kişiselleştirilebilir isim, tarih ve mesaj',
  'Özel hediye kutusunda teslim',
];

export const featuredProducts = [
  {
    id: 17,
    name: 'Mor Çiçek Tablo Tasarımı',
    price: 1200,
    oldPrice: 0,
    image: BASE + 'mor_cicek.png',
    images: [BASE + 'mor_cicek.png'],
    category: 'Dekoratif Tablolar',
    discount: 0,
    rating: 4.9,
    reviewCount: 18,
    stock: 15,
    description: 'Mermer tozu ve kalsiyum karbonat bazlı özel taş tozu harcıyla el yapımı üretilen mor çiçek motifli dekoratif tablo. Pürüzsüz yüzeyi ve mermer efektli yapısıyla mekânınıza lüks bir dokunuş katar. Doğal dokusunun verdiği estetik his, her detayda hissedilir.',
    features: [...commonFeatures, '30x40 cm boyut', 'Mor çiçek motifli özel tasarım'],
    deliveryInfo: '3-5 iş günü içinde kargo',
    slug: 'mor-cicek-tablo-tasarimi',
  },
  {
    id: 18,
    name: 'Mavi Vazo Tablo Tasarımı',
    price: 1200,
    oldPrice: 0,
    image: BASE + 'mavivazo.png',
    images: [BASE + 'mavivazo.png'],
    category: 'Dekoratif Tablolar',
    discount: 0,
    rating: 4.8,
    reviewCount: 14,
    stock: 15,
    description: 'Kalsiyum karbonat bazlı taş tozu harcıyla şekillendirilen, mavi vazo motifli el yapımı dekoratif tablo. Mermer görünümlü pürüzsüz yüzeyi sayesinde modern bir lüks hissi yaratır.',
    features: [...commonFeatures, '30x40 cm boyut', 'Mavi vazo motifli özel tasarım'],
    deliveryInfo: '3-5 iş günü içinde kargo',
    slug: 'mavi-vazo-tablo-tasarimi',
  },
  {
    id: 19,
    name: 'Orkide Tablo Tasarımı',
    price: 1200,
    oldPrice: 0,
    image: BASE + 'orkide1.png',
    images: [BASE + 'orkide1.png'],
    category: 'Dekoratif Tablolar',
    discount: 0,
    rating: 4.9,
    reviewCount: 22,
    stock: 15,
    description: 'Mermer tozu bazlı hobi harcıyla el emeğiyle üretilen, orkide motifli sofistike dekoratif tablo. Yüksek dayanımlı ve doğal dokulu yapısıyla uzun yıllar boyunca güzelliğini korur.',
    features: [...commonFeatures, '30x40 cm boyut', 'Orkide motifli özel tasarım'],
    deliveryInfo: '3-5 iş günü içinde kargo',
    slug: 'orkide-tablo-tasarimi',
  },
  {
    id: 107,
    name: 'Kasımpatı Çiçek Tablo',
    price: 1200,
    oldPrice: 0,
    image: BASE + 'kasimpati.png',
    images: [BASE + 'kasimpati.png'],
    category: 'Dekoratif Tablolar',
    discount: 0,
    rating: 5.0,
    reviewCount: 0,
    stock: 10,
    description: 'Taş tozu harcıyla biçimlendirilen kasımpatı çiçek motifli el yapımı tablo. Ahşap yuvarlak çerçevesiyle çevrili bu eser; doğal dokusu, pürüzsüz yüzeyi ve mermer efektiyle hem şık hem dayanıklı bir hediyeye dönüşür.',
    features: [...commonFeatures, 'Ahşap yuvarlak çerçeve', 'Ø 35 cm boyut', 'Renk seçimi yapılabilir'],
    deliveryInfo: '5-7 iş günü içinde kargo',
    slug: 'kasimpati-cicek-tablo',
  },
  {
    id: 101,
    name: 'Alya & Doruk Çiçek Tablo',
    price: 1200,
    oldPrice: 0,
    image: BASE + 'alya_doruk.png',
    images: [BASE + 'alya_doruk.png'],
    category: 'Dekoratif Tablolar',
    discount: 0,
    rating: 5.0,
    reviewCount: 0,
    stock: 10,
    description: 'İki isim için özel hazırlanan, mermer tozu bazlı taş tozu harcıyla el yapımı çiçek tablo. Pembe çerçevesiyle zarif bir görünüm sunar.',
    features: [...commonFeatures, 'Pembe çerçeveli özel tasarım', '20x25 cm boyut'],
    deliveryInfo: '5-7 iş günü içinde kargo',
    slug: 'alya-doruk-cicek-tablo',
  },
  {
    id: 117,
    name: 'Ufuk & Mert Özel Tasarım Saat',
    price: 1500,
    oldPrice: 0,
    image: BASE + 'ufukmert.png',
    images: [BASE + 'ufukmert.png'],
    category: 'Dekoratif Tablolar',
    discount: 0,
    rating: 5.0,
    reviewCount: 0,
    stock: 10,
    description: 'Kalsiyum karbonat bazlı taş tozu harcıyla üretilen, kişiye özel çiçek motifli el yapımı tablo. İsim ve tarih kişiselleştirmesiyle benzersiz bir hediyeye dönüşür.',
    features: [...commonFeatures, 'Özel çerçeve tasarımı', '20x25 cm boyut'],
    deliveryInfo: '5-7 iş günü içinde kargo',
    slug: 'ufuk-mert-tablo',
  },
  {
    id: 109,
    name: 'Umut Çiçeğim Lale Tablo',
    price: 1200,
    oldPrice: 0,
    image: BASE + 'umut_cicegim.png',
    images: [BASE + 'umut_cicegim.png'],
    category: 'Dekoratif Tablolar',
    discount: 0,
    rating: 5.0,
    reviewCount: 0,
    stock: 10,
    description: 'Mermer tozu ve kalsiyum karbonat bazlı özel hobi harcıyla hazırlanan sarı lale buketi motifli el yapımı tablo. Çiçek desenli özgün çerçevesiyle bütünleşen bu eser; pürüzsüz yüzeyi ve lüks mermer efektiyle sevdiklerinize duygu yüklü bir hediye sunar.',
    features: [...commonFeatures, 'Sarı lale buketi motifli tasarım', 'Çiçek desenli özel çerçeve', '20x25 cm boyut'],
    deliveryInfo: '5-7 iş günü içinde kargo',
    slug: 'umut-cicegim-lale-tablo',
  },

  // Aile & Çift
  {
    id: 24,
    name: 'Çelik Ailesi Lale Çerçevesi',
    price: 1200,
    oldPrice: 0,
    image: BASE + 'celikailesi.png',
    images: [BASE + 'celikailesi.png'],
    category: 'Aile & Çift Tasarımları',
    discount: 0,
    rating: 5.0,
    reviewCount: 0,
    stock: 10,
    description: 'Taş tozu harcıyla biçimlendirilen, aile soyadı kişiselleştirmeli lale buketi çerçeve. Altın sarısı vazo ve pembe lale detaylarıyla zenginleştirilen bu el yapımı eser; dayanıklı yapısı ve lüks mermer efektiyle nesiller boyu hatıra olarak saklanacak bir hediyedir.',
    features: [...commonFeatures, 'Kişiselleştirilebilir aile soyadı', 'Altın sarısı vazo & pembe lale detayları', '20x25 cm boyut'],
    deliveryInfo: '5-7 iş günü içinde kargo',
    slug: 'celik-ailesi-lale-cercevesi',
  },
  {
    id: 115,
    name: 'Öztürk Ailesi Çerçevesi',
    price: 1200,
    oldPrice: 0,
    image: BASE + 'ozturk_ailesi.png',
    images: [BASE + 'ozturk_ailesi.png'],
    category: 'Aile & Çift Tasarımları',
    discount: 0,
    rating: 5.0,
    reviewCount: 0,
    stock: 10,
    description: 'Mermer tozu bazlı hobi harcıyla el emeğiyle üretilen kişiselleştirilebilir aile çerçevesi. Pürüzsüz yüzeyi ve doğal taş dokusuyla evinizin en özel köşesine yakışan bu eser kalıcı bir hatıra sunar.',
    features: [...commonFeatures, 'Kişiselleştirilebilir aile ismi', '20x25 cm boyut'],
    deliveryInfo: '5-7 iş günü içinde kargo',
    slug: 'ozturk-ailesi-cercevesi',
  },
  {
    id: 119,
    name: 'Yıldız Ailesi Çerçevesi',
    price: 1200,
    oldPrice: 0,
    image: BASE + 'Yildiz_ailesi.png',
    images: [BASE + 'Yildiz_ailesi.png'],
    category: 'Aile & Çift Tasarımları',
    discount: 0,
    rating: 5.0,
    reviewCount: 0,
    stock: 10,
    description: 'Kalsiyum karbonat bazlı taş tozu harcıyla el yapımı hazırlanan özel aile çerçevesi. Mermer görünümlü pürüzsüz yüzeyiyle her mekâna lüks bir hava katar.',
    features: [...commonFeatures, 'Kişiselleştirilebilir aile ismi', '20x25 cm boyut'],
    deliveryInfo: '5-7 iş günü içinde kargo',
    slug: 'yildiz-ailesi-cercevesi',
  },
  {
    id: 111,
    name: 'Canım Annem Özel Tablo',
    price: 1200,
    oldPrice: 0,
    image: BASE + 'cnm_annem.jpg',
    images: [BASE + 'cnm_annem.jpg'],
    category: 'Aile & Çift Tasarımları',
    discount: 0,
    rating: 5.0,
    reviewCount: 0,
    stock: 10,
    description: 'Annenize özel olarak hazırlanan, mermer tozu ve kalsiyum karbonat bazlı taş tozu harcıyla el yapımı tablo. Fotoğraf, çiçek ve özel detaylarla bezeli bu eser; anneler günü ve her özel gün için benzersiz bir hatıra armağanıdır.',
    features: [...commonFeatures, 'Fotoğraf & özel detaylı tasarım', 'Anne temalı kişisel içerik', '20x25 cm boyut'],
    deliveryInfo: '5-7 iş günü içinde kargo',
    slug: 'canim-annem-ozel-tablo',
  },

  // Çocuk Tasarımları
  {
    id: 120,
    name: 'Alara Özel Tasarım Saat',
    price: 1500,
    oldPrice: 0,
    image: BASE + 'Alara.png',
    images: [BASE + 'Alara.png'],
    category: 'Çocuk Tasarımları',
    discount: 0,
    rating: 5.0,
    reviewCount: 0,
    stock: 10,
    description: 'Taş tozu harcıyla el emeğiyle üretilen kız çocuğuna özel tablo. Yüksek dayanımlı ve pürüzsüz mermer efektli yüzeyiyle çocuk odasına lüks bir dokunuş katar. İsim ve tarihle kişiselleştirilerek tek bir çocuk için özgün şekilde hazırlanır.',
    features: [...commonFeatures, 'Kız çocuğuna özel figürlü tasarım', '25x30 cm boyut'],
    deliveryInfo: '5-7 iş günü içinde kargo',
    slug: 'alara-ozel-tablo',
  },
  {
    id: 102,
    name: 'Anılcan Çocuk Tablosu',
    price: 1200,
    oldPrice: 0,
    image: BASE + 'An%C4%B1lcan.png',
    images: [BASE + 'An%C4%B1lcan.png'],
    category: 'Çocuk Tasarımları',
    discount: 0,
    rating: 5.0,
    reviewCount: 0,
    stock: 10,
    description: 'Mermer tozu bazlı hobi harcıyla biçimlendirilen, yuvarlak ahşap çerçeveli sevimli çocuk tablosu. Doğal dokulu taş tozu malzemesinin verdiği özgün his; kırılmaya karşı dirençli yapısı ve mermer görünümlü pürüzsüz yüzeyiyle kalıcı bir hatıra oluşturur.',
    features: [...commonFeatures, 'Yuvarlak ahşap çerçeve', 'Ø 35 cm boyut'],
    deliveryInfo: '5-7 iş günü içinde kargo',
    slug: 'anilcan-cocuk-tablosu',
  },
  {
    id: 103,
    name: 'Büşra Özel Tablo',
    price: 1200,
    oldPrice: 0,
    image: BASE + 'busenaz.png',
    images: [BASE + 'busenaz.png'],
    category: 'Çocuk Tasarımları',
    discount: 0,
    rating: 5.0,
    reviewCount: 0,
    stock: 10,
    description: 'Kalsiyum karbonat bazlı taş tozu harcıyla el yapımı üretilen, pembe çerçeveli kişiye özel tablo. Lüks mermer efekti ve doğal dokulu yüzeyi; bu eseri sıradan bir hediyeden çok öte, sanatsal bir objeye dönüştürür.',
    features: [...commonFeatures, 'Pembe çerçeveli özel tasarım', '25x30 cm boyut'],
    deliveryInfo: '5-7 iş günü içinde kargo',
    slug: 'busenaz-ozel-tablo',
  },
  {
    id: 110,
    name: 'Büşra Çiçek Tablo',
    price: 1200,
    oldPrice: 0,
    image: BASE + 'B%C3%BC%C5%9Fra.png',
    images: [BASE + 'B%C3%BC%C5%9Fra.png'],
    category: 'Çocuk Tasarımları',
    discount: 0,
    rating: 5.0,
    reviewCount: 0,
    stock: 10,
    description: 'Mermer tozu ve kalsiyum karbonat bazlı hobi harcıyla el emeğiyle şekillendirilen çiçek temalı kişisel tablo. Pürüzsüz yüzeyi, doğal taş dokusu ve mermer efektiyle sanatsal bir estetik sunar.',
    features: [...commonFeatures, 'Çiçek temalı özel tasarım', '25x30 cm boyut'],
    deliveryInfo: '5-7 iş günü içinde kargo',
    slug: 'busra-cicek-tablo',
  },
  {
    id: 112,
    name: 'Dilara Özel Tablo',
    price: 1200,
    oldPrice: 0,
    image: BASE + 'Dilara.png',
    images: [BASE + 'Dilara.png'],
    category: 'Çocuk Tasarımları',
    discount: 0,
    rating: 5.0,
    reviewCount: 0,
    stock: 10,
    description: 'Taş tozu harcıyla biçimlendirilen kişiye özel sevimli çocuk tablosu. Yüksek dayanımlı ve mermer görünümlü bu el yapımı eser; çocuğunuzun adını ve doğum tarihini sonsuza dek taşıyacak özel bir hatıra objesidir.',
    features: [...commonFeatures, 'Kişiselleştirilebilir isim & tarih', 'Özel çerçeve tasarımı', '25x30 cm boyut'],
    deliveryInfo: '5-7 iş günü içinde kargo',
    slug: 'dilara-ozel-tablo',
  },
  {
    id: 113,
    name: 'Emrecan Özel Tasarım Saat',
    price: 1500,
    oldPrice: 0,
    image: BASE + 'Emrecan.png',
    images: [BASE + 'Emrecan.png'],
    category: 'Çocuk Tasarımları',
    discount: 0,
    rating: 5.0,
    reviewCount: 0,
    stock: 10,
    description: 'Kalsiyum karbonat bazlı taş tozu harcıyla el yapımı üretilen erkek çocuğa özel tablo. Pürüzsüz mermer görünümü ve doğal dokusuyla çocuğunuza özel benzersiz bir esere dönüşür.',
    features: [...commonFeatures, 'Erkek çocuğuna özel figürlü tasarım', 'Ø 35 cm boyut'],
    deliveryInfo: '5-7 iş günü içinde kargo',
    slug: 'emrecan-ozel-tablo',
  },
  {
    id: 114,
    name: 'Hababam Özel Tasarım Saat',
    price: 1500,
    oldPrice: 0,
    image: BASE + 'hababam.png',
    images: [BASE + 'hababam.png'],
    category: 'Çocuk Tasarımları',
    discount: 0,
    rating: 5.0,
    reviewCount: 0,
    stock: 10,
    description: 'Mermer tozu ve kalsiyum karbonat bazlı taş tozu harcıyla şekillendirilen neşeli temalı çocuk tablosu. El emeği ve doğal dokulu yapısıyla her detayda özgünlük sunan bu eser; çocuk odasına hem renk hem anlam katar.',
    features: [...commonFeatures, 'Neşeli figürlü renkli tasarım', '25x30 cm boyut'],
    deliveryInfo: '5-7 iş günü içinde kargo',
    slug: 'hababam-ozel-tablo',
  },
  {
    id: 116,
    name: 'Sıla Özel Tasarım Saat',
    price: 1500,
    oldPrice: 0,
    image: BASE + 'SILA.png',
    images: [BASE + 'SILA.png'],
    category: 'Çocuk Tasarımları',
    discount: 0,
    rating: 5.0,
    reviewCount: 0,
    stock: 10,
    description: 'Mermer tozu bazlı hobi harcıyla el emeğiyle üretilen kız çocuğuna özel sevimli tablo. Kırılmaya karşı dirençli, doğal dokulu yapısı ve mermer görünümlü pürüzsüz yüzeyiyle odada öne çıkan estetik bir objedir.',
    features: [...commonFeatures, 'Kız çocuğuna özel figürlü tasarım', '25x30 cm boyut'],
    deliveryInfo: '5-7 iş günü içinde kargo',
    slug: 'sila-ozel-tablo',
  },
  {
    id: 118,
    name: 'Yiğit Can Özel Tablo',
    price: 1200,
    oldPrice: 0,
    image: BASE + 'yigit_can.png',
    images: [BASE + 'yigit_can.png'],
    category: 'Çocuk Tasarımları',
    discount: 0,
    rating: 5.0,
    reviewCount: 0,
    stock: 10,
    description: 'Kalsiyum karbonat bazlı taş tozu harcıyla el yapımı üretilen erkek çocuğa özel tablo. Lüks mermer efekti, doğal taş dokusu ve yüksek dayanımlı yapısıyla çocuğunuzun ismiyle benzersiz bir hatıraya dönüşür.',
    features: [...commonFeatures, 'Erkek çocuğuna özel figürlü tasarım', 'Ø 35 cm boyut'],
    deliveryInfo: '5-7 iş günü içinde kargo',
    slug: 'yigit-can-ozel-tablo',
  },
  {
    id: 104,
    name: 'Eda Balonlu Kız Tablo',
    price: 1200,
    oldPrice: 0,
    image: BASE + 'eda.png',
    images: [BASE + 'eda.png'],
    category: 'Çocuk Tasarımları',
    discount: 0,
    rating: 5.0,
    reviewCount: 0,
    stock: 10,
    description: 'Mermer tozu bazlı hobi harcıyla el emeğiyle üretilen, balonlu kız figürlü yuvarlak ahşap çerçeveli tablo. Doğal taş dokusu ve mermer efektli pürüzsüz yüzeyiyle şıklık ve duygusallığı bir araya getirir.',
    features: [...commonFeatures, 'Balonlu kız figürlü tasarım', 'Ahşap yuvarlak çerçeve', 'Ø 35 cm boyut'],
    deliveryInfo: '5-7 iş günü içinde kargo',
    slug: 'eda-balonlu-kiz-tablo',
  },
  {
    id: 108,
    name: 'Mertcan Ev & Araba Tablo',
    price: 1200,
    oldPrice: 0,
    image: BASE + 'mertcan.png',
    images: [BASE + 'mertcan.png'],
    category: 'Çocuk Tasarımları',
    discount: 0,
    rating: 5.0,
    reviewCount: 0,
    stock: 10,
    description: 'Taş tozu harcıyla biçimlendirilen, ev ve araba temalı yuvarlak çerçeveli çocuk tablosu. Doğal dokulu ve lüks mermer efektli pürüzsüz yüzeyi; bu el yapımı eseri erkek çocukları için ideal, dayanıklı ve kişisel bir hediyeye dönüştürür.',
    features: [...commonFeatures, 'Ev, araba & doğa figürlü tasarım', 'Yuvarlak çerçeve', 'Ø 35 cm boyut'],
    deliveryInfo: '5-7 iş günü içinde kargo',
    slug: 'mertcan-ev-araba-tablo',
  },

  // Bebek Odası Tasarımları
  {
    id: 105,
    name: 'Eslemnur Tavşan Tablo',
    price: 1200,
    oldPrice: 0,
    image: BASE + 'Eslemnur_tavsan.png',
    images: [BASE + 'Eslemnur_tavsan.png'],
    category: 'Bebek Odası Tasarımları',
    discount: 0,
    rating: 5.0,
    reviewCount: 0,
    stock: 10,
    description: 'Mermer tozu ve kalsiyum karbonat bazlı taş tozu harcıyla el emeğiyle üretilen, pembe kare çerçeveli tavşan figürlü bebek odası tablosu. Doğal dokulu ve mermer efektli pürüzsüz yüzeyi; bu pastel tonlu eseri bebek odalarına özel, lüks hissettiren bir hediyeye dönüştürür.',
    features: [...commonFeatures, 'Tavşan & balon figürlü pastel tasarım', 'Pembe kare çerçeve', '20x25 cm boyut'],
    deliveryInfo: '5-7 iş günü içinde kargo',
    slug: 'eslemnur-tavsan-tablo',
  },
  {
    id: 106,
    name: 'Eymenalp Tavşan Tablo',
    price: 1200,
    oldPrice: 0,
    image: BASE + 'eymenalp_tavsan.png',
    images: [BASE + 'eymenalp_tavsan.png'],
    category: 'Bebek Odası Tasarımları',
    discount: 0,
    rating: 5.0,
    reviewCount: 0,
    stock: 10,
    description: 'Taş tozu harcıyla biçimlendirilen, mavi yuvarlak çerçeveli tavşan ve sıcak hava balonu figürlü bebek odası tablosu. Yüksek dayanımlı, kırılmaya karşı dirençli ve mermer görünümlü bu el yapımı eser; bebeğinizin odasına şiirsel bir anlam katar.',
    features: [...commonFeatures, 'Tavşan & sıcak hava balonu figürlü', 'Mavi yuvarlak ahşap çerçeve', 'Ø 35 cm boyut'],
    deliveryInfo: '5-7 iş günü içinde kargo',
    slug: 'eymenalp-tavsan-tablo',
  },
];

export const productReviews: Record<number, Array<{ name: string; rating: number; comment: string; date: string; avatar: string }>> = {};
